import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e786910"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lf-form" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

import {
  ref,
  watch,
  withDefaults,
  reactive
} from 'vue'
import { IFormItem } from '@/components/types'
import { ElForm, ElAutocomplete, ElMessageBox, ElMessage } from 'element-plus'
import store from '@/store'
import dayjs from 'dayjs'
import {getListData} from "@/service/main/system";


export default /*#__PURE__*/_defineComponent({
  __name: 'lf-form',
  props: {
    modelValue: {},
    formItems: { default: () => [] },
    labelWidth: { default: '100px' },
    itemStyle: { default: () => ({ padding: '10px 10px' }) },
    colLayout: { default: () => ({
      xl: 8,
      lg: 8,
      md: 12,
      sm: 24,
      xs: 24
    }) }
  },
  emits: ["update:modelValue", "select", "change"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props
const autocompleteRef = ref<InstanceType<typeof ElAutocomplete>>()

const formData = ref({ ...props.modelValue })
const formItems = ref([...props.formItems])
const emit = __emit

const handleSelect = (item: any) => {
  emit('select', item)
}

const changeSelect = (item: any, value: any,formData:any) => {
  emit('change', item, value, formData)
  if (item.descField && item.change && typeof item.change == 'function') {
    formData[item.descField] = item.change(value)
  }
  if (item.otherOptions && item.otherOptions.ctlField) {
    formItems.value.forEach((obj: IFormItem) => {
      if (
        obj.field == item.otherOptions.ctlField &&
        typeof item.otherOptions.check == 'function'
      ) {
        obj.otherOptions.disabled = item.otherOptions.check(value)
      }
    })
  }
  if (item.otherOptions && item.otherOptions.changeField) {
    formItems.value.forEach((obj: IFormItem) => {
      if (obj.field == item.otherOptions.changeField) {
        const param: any = {}
        item.otherOptions.params.forEach((item: any) => {
          param[item.key] = formData[item.field]
        })
        getListData(item.otherOptions.changeUrl, param).then(res => {
          obj.options = res.map((item: any) => {
            return {title: item, value: item};
          })
        })
      }
    })
  }
}

const handleClear = () => {
  document.activeElement.blur()
}

const add = (formData: any, field: string) => {
  if (!formData[field]) {
    formData[field] = []
  }
  formData[field].push('')
}

watch(
  formData,
  (newValue) => {
    console.log(newValue)
    emit('update:modelValue', newValue)
  },
  {
    deep: true
  }
)

const formRef = ref<InstanceType<typeof ElForm>>()
const validate = (cb: (isValid: boolean | undefined) => void) => {
  formRef.value?.validate(cb)
}
const allDisabled=ref(false);

const defaultTime: [Date, Date] = [
  new Date(2000, 1, 1, 0, 0, 0),
  new Date(2000, 1, 1, 23, 59, 59)
]

__expose({
  validate,
  allDisabled
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_time_picker = _resolveComponent("el-time-picker")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _renderSlot(_ctx.$slots, "header")
    ]),
    _createVNode(_unref(ElForm), {
      "label-width": _ctx.labelWidth,
      model: formData.value,
      ref_key: "formRef",
      ref: formRef,
      disabled: allDisabled.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formItems.value, (item) => {
              return (_openBlock(), _createBlock(_component_el_col, _mergeProps({
                key: item.label,
                ref_for: true
              }, _ctx.colLayout), {
                default: _withCtx(() => [
                  (!item.isHidden)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        class: _normalizeClass(item.class || item.field),
                        label: item.label,
                        prop: item.field,
                        rules: item.rules,
                        style: _normalizeStyle(item.styles ? item.styles : _ctx.itemStyle),
                        "label-width": item.labelWidth
                      }, {
                        default: _withCtx(() => [
                          (item.type === 'inputRate')
                            ? (_openBlock(), _createBlock(_component_el_input, _mergeProps({
                                key: 0,
                                type: "number",
                                ref_for: true
                              }, item.otherOptions, {
                                placeholder: item.placeholder,
                                modelValue: formData.value[`${item.field}`],
                                "onUpdate:modelValue": ($event: any) => ((formData.value[`${item.field}`]) = $event),
                                disabled: item.isDisabled,
                                maxlength: item.maxLength
                              }), {
                                suffix: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.suffix) + "%", 1)
                                ]),
                                _: 2
                              }, 1040, ["placeholder", "modelValue", "onUpdate:modelValue", "disabled", "maxlength"]))
                            : _createCommentVNode("", true),
                          (item.type === 'input' || item.type === 'password')
                            ? (_openBlock(), _createBlock(_component_el_input, _mergeProps({
                                key: 1,
                                clearable: item.clearable,
                                ref_for: true
                              }, item.otherOptions, {
                                placeholder: item.placeholder,
                                "show-password": item.type === 'password',
                                modelValue: formData.value[`${item.field}`],
                                "onUpdate:modelValue": ($event: any) => ((formData.value[`${item.field}`]) = $event),
                                disabled: item.isDisabled,
                                class: item.class,
                                maxlength: item.maxLength
                              }), {
                                suffix: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.suffix), 1)
                                ]),
                                _: 2
                              }, 1040, ["clearable", "placeholder", "show-password", "modelValue", "onUpdate:modelValue", "disabled", "class", "maxlength"]))
                            : _createCommentVNode("", true),
                          ('number' === item.type)
                            ? (_openBlock(), _createBlock(_component_el_input, _mergeProps({
                                key: 2,
                                type: "number",
                                ref_for: true
                              }, item.otherOptions, {
                                placeholder: item.placeholder,
                                modelValue: formData.value[`${item.field}`],
                                "onUpdate:modelValue": ($event: any) => ((formData.value[`${item.field}`]) = $event),
                                disabled: item.isDisabled,
                                maxlength: item.maxLength
                              }), _createSlots({ _: 2 }, [
                                (item.suffix)
                                  ? {
                                      name: "suffix",
                                      fn: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.suffix), 1)
                                      ]),
                                      key: "0"
                                    }
                                  : undefined
                              ]), 1040, ["placeholder", "modelValue", "onUpdate:modelValue", "disabled", "maxlength"]))
                            : _createCommentVNode("", true),
                          ('percent' === item.type)
                            ? (_openBlock(), _createBlock(_component_el_input, _mergeProps({
                                key: 3,
                                type: "number",
                                ref_for: true
                              }, item.otherOptions, {
                                placeholder: item.placeholder,
                                modelValue: formData.value[`${item.field}`],
                                "onUpdate:modelValue": ($event: any) => ((formData.value[`${item.field}`]) = $event),
                                disabled: item.isDisabled,
                                oninput: "if(value > 100) value = 100;"
                              }), {
                                suffix: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.suffix), 1)
                                ]),
                                _: 2
                              }, 1040, ["placeholder", "modelValue", "onUpdate:modelValue", "disabled"]))
                            : _createCommentVNode("", true),
                          (item.type === 'default')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                (
                    formData.value[`${item.field}`] == null &&
                    'empName' === item.field
                  )
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(_toDisplayString(_unref(store).state.login.userInfo.realName), 1)
                                    ], 64))
                                  : (
                    formData.value[`${item.field}`] == null &&
                    'fillDate' === item.field
                  )
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode(_toDisplayString(_unref(dayjs)().format('YYYY-MM-DD hh:mm:ss')), 1)
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                        _createTextVNode(_toDisplayString(formData.value[`${item.field}`]), 1)
                                      ], 64))
                              ], 64))
                            : _createCommentVNode("", true),
                          (item.type === 'autocomplete')
                            ? (_openBlock(), _createBlock(_unref(ElAutocomplete), _mergeProps({
                                key: 5,
                                ref_for: true
                              }, item.otherOptions, {
                                placeholder: item.placeholder,
                                style: {"width":"100%"},
                                modelValue: formData.value[`${item.field}`],
                                "onUpdate:modelValue": ($event: any) => ((formData.value[`${item.field}`]) = $event),
                                disabled: item.isDisabled,
                                onSelect: handleSelect,
                                onClear: handleClear,
                                ref_for: true,
                                ref_key: "autocompleteRef",
                                ref: autocompleteRef,
                                "popper-class": "el-autocomplete-suggestion",
                                "popper-append-to-body": true
                              }), null, 16, ["placeholder", "modelValue", "onUpdate:modelValue", "disabled"]))
                            : (item.type === 'select')
                              ? (_openBlock(), _createBlock(_component_el_select, _mergeProps({
                                  key: 6,
                                  clearable: item.clearable,
                                  filterable: item.filterable,
                                  placeholder: item.placeholder,
                                  style: {"width":"100%"},
                                  disabled: item.isDisabled,
                                  multiple: item.multiple,
                                  onChange: ($event: any) => (changeSelect(item, formData.value[`${item.field}`],formData.value)),
                                  modelValue: formData.value[`${item.field}`],
                                  "onUpdate:modelValue": ($event: any) => ((formData.value[`${item.field}`]) = $event),
                                  ref_for: true
                                }, item.otherOptions), _createSlots({
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, (option) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: option.value,
                                        value: option.value,
                                        label: option.title
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(option.title), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["value", "label"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, [
                                  (item.suffix)
                                    ? {
                                        name: "prefix",
                                        fn: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.suffix), 1)
                                        ]),
                                        key: "0"
                                      }
                                    : undefined
                                ]), 1040, ["clearable", "filterable", "placeholder", "disabled", "multiple", "onChange", "modelValue", "onUpdate:modelValue"]))
                              : (item.type === 'datepicker')
                                ? (_openBlock(), _createBlock(_component_el_date_picker, _mergeProps({
                                    key: 7,
                                    style: {"width":"100%"},
                                    onChange: ($event: any) => (changeSelect(item, formData.value[`${item.field}`],formData.value)),
                                    clearable: item.clearable,
                                    ref_for: true
                                  }, item.otherOptions, {
                                    disabled: item.isDisabled,
                                    modelValue: formData.value[`${item.field}`],
                                    "onUpdate:modelValue": ($event: any) => ((formData.value[`${item.field}`]) = $event)
                                  }), null, 16, ["onChange", "clearable", "disabled", "modelValue", "onUpdate:modelValue"]))
                                : (item.type === 'dateTimePicker')
                                  ? (_openBlock(), _createBlock(_component_el_date_picker, _mergeProps({
                                      key: 8,
                                      style: {"width":"100%"},
                                      ref_for: true
                                    }, item.otherOptions, {
                                      type: "datetimerange",
                                      "value-format": "YYYY-MM-DD HH:mm:ss",
                                      "default-time": defaultTime,
                                      disabled: item.isDisabled,
                                      modelValue: formData.value[`${item.field}`],
                                      "onUpdate:modelValue": ($event: any) => ((formData.value[`${item.field}`]) = $event)
                                    }), null, 16, ["disabled", "modelValue", "onUpdate:modelValue"]))
                                  : (item.type === 'timePicker')
                                    ? (_openBlock(), _createBlock(_component_el_time_picker, _mergeProps({
                                        key: 9,
                                        "is-range": "",
                                        style: {"width":"100%"},
                                        ref_for: true
                                      }, item.otherOptions, {
                                        modelValue: formData.value[`${item.field}`],
                                        "onUpdate:modelValue": ($event: any) => ((formData.value[`${item.field}`]) = $event),
                                        "range-separator": "-",
                                        "start-placeholder": "开始时间",
                                        "end-placeholder": "结束时间",
                                        "picker-options": {
                    minTime: '00:00:00',
                    maxTime: '23:59:59'
                  }
                                      }), null, 16, ["modelValue", "onUpdate:modelValue"]))
                                    : (item.type === 'cascader')
                                      ? (_openBlock(), _createBlock(_component_el_cascader, _mergeProps({
                                          key: 10,
                                          options: item.options,
                                          ref_for: true
                                        }, item.otherOptions, {
                                          style: {"width":"100%"},
                                          placeholder: item.placeholder,
                                          modelValue: formData.value[`${item.field}`],
                                          "onUpdate:modelValue": ($event: any) => ((formData.value[`${item.field}`]) = $event)
                                        }), null, 16, ["options", "placeholder", "modelValue", "onUpdate:modelValue"]))
                                      : (item.type === 'switch')
                                        ? (_openBlock(), _createBlock(_component_el_switch, {
                                            key: 11,
                                            modelValue: formData.value[`${item.field}`],
                                            "onUpdate:modelValue": ($event: any) => ((formData.value[`${item.field}`]) = $event),
                                            "active-value": item.activeValue ? item.activeValue : true,
                                            "inactive-value": 
                    typeof item.inActiveValue != 'undefined'
                      ? item.inActiveValue
                      : false
                  
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "active-value", "inactive-value"]))
                                        : (item.type === 'textarea')
                                          ? (_openBlock(), _createBlock(_component_el_input, _mergeProps({
                                              key: 12,
                                              type: "textarea",
                                              rows: item.rows,
                                              autosize: { minRows: 2, maxRows: 6 },
                                              ref_for: true
                                            }, item.otherOptions, {
                                              placeholder: item.placeholder,
                                              modelValue: formData.value[`${item.field}`],
                                              "onUpdate:modelValue": ($event: any) => ((formData.value[`${item.field}`]) = $event),
                                              disabled: formData.value['isDisabled'] || item.isDisabled,
                                              maxlength: item.maxLength
                                            }), null, 16, ["rows", "placeholder", "modelValue", "onUpdate:modelValue", "disabled", "maxlength"]))
                                          : (item.type === 'textareas')
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 13 }, [
                                                (formData.value[item.field] && formData.value[item.field].length > 0)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.value[item.field], (val, index) => {
                                                        return (_openBlock(), _createElementBlock("div", {
                                                          key: index,
                                                          style: {"display":"flex"}
                                                        }, [
                                                          _createVNode(_component_el_input, {
                                                            modelValue: formData.value[item.field][index],
                                                            "onUpdate:modelValue": ($event: any) => ((formData.value[item.field][index]) = $event),
                                                            autosize: "",
                                                            type: "textarea",
                                                            placeholder: `请输入第${index + 1}个标题`
                                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]),
                                                          (
                        formData.value[item.ctrlField] === 5 ||
                        (formData.value[item.ctrlField] != 5 &&
                          formData.value[item.field].length == 0)
                      )
                                                            ? (_openBlock(), _createBlock(_component_el_button, {
                                                                key: 0,
                                                                type: "primary",
                                                                style: {"margin-left":"10px"},
                                                                icon: "el-icon-plus",
                                                                size: "mini",
                                                                onClick: ($event: any) => (add(formData.value, item.field))
                                                              }, null, 8, ["onClick"]))
                                                            : _createCommentVNode("", true)
                                                        ]))
                                                      }), 128))
                                                    ]))
                                                  : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                                      _createVNode(_component_el_button, {
                                                        type: "primary",
                                                        style: {"margin-left":"10px"},
                                                        icon: "el-icon-plus",
                                                        size: "mini",
                                                        onClick: ($event: any) => (add(formData.value, item.field))
                                                      }, null, 8, ["onClick"])
                                                    ]))
                                              ], 64))
                                            : (item.type === 'customSlot')
                                              ? _renderSlot(_ctx.$slots, `field-${item.field}`, {
                                                  key: 14,
                                                  data: formData.value
                                                })
                                              : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["class", "label", "prop", "rules", "style", "label-width"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1040))
            }), 128))
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["label-width", "model", "disabled"]),
    _createElementVNode("div", null, [
      _renderSlot(_ctx.$slots, "footer")
    ])
  ]))
}
}

})